import React from "react";
import { useSelector } from "react-redux";
import get from "lodash/get";
import {
  AuthorDetails,
  FollowUs,
  Headline,
  PublishDetails,
  ReadTime,
  SocialShareIcons,
  SubHeadline,
} from "../../atoms";
import "./gn-reach-template.m.css";

export default function StoryDetails({ story }) {
  const timezone = useSelector((state) => get(state, ["qt", "data", "timezone"], null));
  const layoutType = get(story, ["metadata", "story-attributes", "layout", "0"], "");
  const topDivWrapper = layoutType === "Headline_First" ? "headline-first-top-div" : "image-first-top-div";
  return (
    <div styleName={topDivWrapper}>
      <Headline headline={story?.headline} />
      <SubHeadline subheadline={story?.subheadline} />
      <div>
        <PublishDetails story={story} template="story" timezone={timezone} />
        <AuthorDetails story={story} />
      </div>

      <div styleName="read-time-social-share-div">
        <ReadTime time={story?.["read-time"]} />
        <span styleName="follow-us-share">
          <FollowUs />
          <SocialShareIcons story={story} imageDimension={{ width: "34px", height: "34px", viewbox: "0 0 34 34" }} />
        </span>
      </div>
    </div>
  );
}
